import { createFileRoute, stripSearchParams, useNavigate } from '@tanstack/react-router'

import { FocusSearchTermPage } from '@/components/Ams/FocusSearchTermPage'
import { focusSearchSchema, pruned } from '@/components/Ams/search'
import { EMPTY_PRIMARY_FILTERS } from '@/lib/filters'

/** Wiring only. The schema lives beside the page in `search.ts`. */
export const Route = createFileRoute('/_app/focused-data/search-term/sheet/')({
  validateSearch: focusSearchSchema,
  // A link to this page carries no defaults: the clean URL is the default view.
  search: { middlewares: [stripSearchParams(EMPTY_PRIMARY_FILTERS)] },
  component: SheetRoute,
})

function SheetRoute() {
  const search = Route.useSearch()
  const navigate = useNavigate({ from: Route.fullPath })

  return (
    <FocusSearchTermPage
      search={search}
      onSearchChange={(next) =>
        void navigate({ search: (current) => pruned({ ...current, ...next }), replace: true })
      }
    />
  )
}
